import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/personalData';
/* istanbul ignore next */
function validatePersonalDataSuccess(state, action) {
  const { code, message, tokenProcess: token, resultadoPersona } = action.payload;
  state.validatePersonalData = {
    success: true,
    error: false,
    code,
    message,
    token,
    /* istanbul ignore next */
    person: {
      /* istanbul ignore next */
      firstName: resultadoPersona.personaNatural.primerNombre || '',
      /* istanbul ignore next */
      lastName: resultadoPersona.personaNatural.primerApellido || '',
      /* istanbul ignore next */
      maternalLastName: resultadoPersona.personaNatural.segundoApellido || '',
      /* istanbul ignore next */
      profession: resultadoPersona.detalleProfesiones || '',
      /* istanbul ignore next */
      nationality: resultadoPersona.personaNatural.nacionalidad || '',
    },
  };
}

function validatePersonalDataError(state, action) {
  const { code, message } = action.payload;
  state.validatePersonalData = {
    success: false,
    error: true,
    code,
    message,
  };
}

function registerPersonalDataSuccess(state, action) {
  const { email, address, phone, code, message } = action.payload;
  state.email = email;
  state.address = address;
  state.phone = phone;
  state.registerPersonalData = {
    success: true,
    error: false,
    code,
    message,
  };
}

function registerPersonalDataError(state, action) {
  const { code, message } = action.payload;
  state.email = null;
  state.address = null;
  state.registerPersonalData = {
    success: false,
    error: true,
    code,
    message,
  };
}

function changeStateBadSerial(state, action) {
  const { stateSerial } = action.payload
  state.badSerialNumber = stateSerial
}

const validatePersonalData = createAction('validatePersonalData')
const registerPersonalData = createAction('registerPersonalData');

const personalDataReducer = createSlice({
  name: 'personalData',
  initialState,
  reducers: {
    validatePersonalDataSuccess,
    validatePersonalDataError,
    registerPersonalDataSuccess,
    registerPersonalDataError,
    changeStateBadSerial
  },
});

export const personalDataActions = {
  ...personalDataReducer.actions,
  validatePersonalData,
  registerPersonalData,
};

export default personalDataReducer.reducer;
